// Which courses a beneficiary may see (namat#36 P1-10).
//
// Kept byte-identical in namat (web) and namat-mobile so both sides apply
// the same rule. The admin/instructor editor (web CourseManagement.tsx)
// writes one of two shapes:
//   general:      { contentMode: 'general',      isOrganizationOnly: false }
//   organization: { contentMode: 'organization', isOrganizationOnly: true, organizationId }
// A general course is for everyone. An organization course is for members of
// that organization, and only while it is their active organization: the
// dashboard is scoped to one organization at a time.
//
// Courses carry no published/draft flag today, so there is nothing to hide
// on that axis.

export interface CourseVisibilityFields {
  contentMode?: string;
  isOrganizationOnly?: boolean;
  organizationId?: string | null;
}

export function isOrganizationCourse(course: CourseVisibilityFields): boolean {
  return course.isOrganizationOnly === true || course.contentMode === 'organization';
}

export function isCourseVisibleTo(
  course: CourseVisibilityFields,
  activeOrgId: string | null | undefined
): boolean {
  if (!isOrganizationCourse(course)) return true;
  // An organization course with no organization recorded belongs to nobody.
  if (!course.organizationId || !activeOrgId) return false;
  return course.organizationId === activeOrgId;
}

export function visibleCourses<T extends CourseVisibilityFields>(
  courses: T[],
  activeOrgId: string | null | undefined
): T[] {
  return courses.filter(course => isCourseVisibleTo(course, activeOrgId));
}
